import React, { useState } from 'react';

const AddStudent = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    roll: '',
    class: 'Grade 10',
    section: 'A',
    session: '2023-2024',
    dateOfBirth: '',
    bloodGroup: '',
    guardianName: '',
    guardianPhone: '',
    phone: '',
    address: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, this would submit to an API
    console.log('Student created:', formData);
    alert('Student created successfully!');
    setFormData({
      name: '',
      email: '',
      password: '',
      roll: '',
      class: 'Grade 10',
      section: 'A',
      session: '2023-2024',
      dateOfBirth: '',
      bloodGroup: '',
      guardianName: '',
      guardianPhone: '',
      phone: '',
      address: ''
    });
  };

  return (
    <div className="min-h-screen py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">Add New Student</h1>
        
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="name" className="block text-gray-700 mb-2">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                  placeholder="Enter student's full name"
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-gray-700 mb-2">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                  placeholder="Enter email address"
                />
              </div>
              
              <div>
                <label htmlFor="password" className="block text-gray-700 mb-2">Password *</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                  placeholder="Enter password"
                />
              </div>
              
              <div>
                <label htmlFor="roll" className="block text-gray-700 mb-2">Roll Number *</label>
                <input
                  type="text"
                  id="roll"
                  name="roll"
                  value={formData.roll}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                  placeholder="Enter roll number"
                />
              </div>
              
              <div>
                <label htmlFor="class" className="block text-gray-700 mb-2">Class *</label>
                <select
                  id="class"
                  name="class"
                  value={formData.class}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                >
                  <option value="Nursery">Nursery</option>
                  <option value="KG">KG</option>
                  <option value="Grade 1">Grade 1</option>
                  <option value="Grade 2">Grade 2</option>
                  <option value="Grade 3">Grade 3</option>
                  <option value="Grade 4">Grade 4</option>
                  <option value="Grade 5">Grade 5</option>
                  <option value="Grade 6">Grade 6</option>
                  <option value="Grade 7">Grade 7</option>
                  <option value="Grade 8">Grade 8</option>
                  <option value="Grade 9">Grade 9</option>
                  <option value="Grade 10">Grade 10</option>
                  <option value="Grade 11">Grade 11</option>
                  <option value="Grade 12">Grade 12</option>
                </select>
              </div>
              
              <div>
                <label htmlFor="section" className="block text-gray-700 mb-2">Section *</label>
                <select
                  id="section"
                  name="section"
                  value={formData.section}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                >
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                </select>
              </div>
              
              <div>
                <label htmlFor="session" className="block text-gray-700 mb-2">Session *</label>
                <input
                  type="text"
                  id="session"
                  name="session"
                  value={formData.session}
                  onChange={handleChange}
                  required
                  className="w-full p-2 border rounded"
                  placeholder="e.g. 2023-2024"
                />
              </div>
              
              <div>
                <label htmlFor="dateOfBirth" className="block text-gray-700 mb-2">Date of Birth</label>
                <input
                  type="date"
                  id="dateOfBirth"
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                />
              </div>
              
              <div>
                <label htmlFor="bloodGroup" className="block text-gray-700 mb-2">Blood Group</label>
                <input
                  type="text"
                  id="bloodGroup"
                  name="bloodGroup"
                  value={formData.bloodGroup}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="e.g. O+, AB-"
                />
              </div>
              
              <div>
                <label htmlFor="phone" className="block text-gray-700 mb-2">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full p-2 border rounded"
                  placeholder="Enter phone number"
                />
              </div>
            </div>
            
            <div className="mb-6">
              <label htmlFor="address" className="block text-gray-700 mb-2">Address</label>
              <textarea
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                rows="3"
                className="w-full p-2 border rounded"
                placeholder="Enter address"
              ></textarea>
            </div>
            
            <div className="border-t pt-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">Guardian Information</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="guardianName" className="block text-gray-700 mb-2">Guardian Name *</label>
                  <input
                    type="text"
                    id="guardianName"
                    name="guardianName"
                    value={formData.guardianName}
                    onChange={handleChange}
                    required
                    className="w-full p-2 border rounded"
                    placeholder="Enter guardian's name"
                  />
                </div>
                
                <div>
                  <label htmlFor="guardianPhone" className="block text-gray-700 mb-2">Guardian Phone *</label>
                  <input
                    type="tel"
                    id="guardianPhone"
                    name="guardianPhone"
                    value={formData.guardianPhone}
                    onChange={handleChange}
                    required
                    className="w-full p-2 border rounded"
                    placeholder="Enter guardian's phone number"
                  />
                </div>
              </div>
            </div>
            
            <div className="flex justify-end space-x-4">
              <a href="/admin/students" className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600 transition">
                Cancel
              </a>
              <button
                type="submit"
                className="bg-primary text-white px-6 py-2 rounded hover:bg-blue-700 transition"
              >
                Add Student
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddStudent;